export const ALERT_SUPPLEMENTAL = 1;
export const LESSON_SUPPLEMENTAL = 0;
